import { useEffect, useRef } from "react";

export function EavailableWorks() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const paragraphs = sectionRef.current.querySelectorAll("p");
                if (entry.isIntersecting) {

                    paragraphs.forEach((p, index) => {
                        setTimeout(() => {
                            p.classList.add("show");
                        }, index * 350);
                    });

                } else {
                    paragraphs.forEach((p) => {
                        p.classList.remove("show");
                    });
                }
            },
            {
                threshold: 0.3
            }
        );

        observer.observe(sectionRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <section ref={sectionRef} className="works">
            <div className="works-tittle">
                <h2 className="rainbow">Specialized manteinance</h2>
            </div>
            <div className="works-subcontainer">
                <p>
                    Industrial Ventilation & Extraction
                </p>
                <p>
                    Industrial Dust Collection Systems
                </p>
                <p>
                    Industrial Refrigeration Systems
                </p>
                <p>
                    Cooling Towers
                </p>
                <p>
                    VRV & VRF Systems
                </p>
                <img src="../videos/IndustrialPipes.svg" width={640} height={480} alt="industrial animation"></img>
            </div>
        </section>
    )
}